export default __webpack_public_path__ + "static/media/home_img-top.3bd98f4d-2new.d9e1d2f0.jpg";